import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',

    '@media (max-width: 1180px)': {
      minHeight: '100vh',
    },
  },
  container: {
    display: 'flex',
    flex: 1,
  },
  mobileContainer: {
    width: 320,
    height: 'fit-content',
    background: '#FAFAFA',
  },
  drawer: {
    position: 'fixed',
    flexWrap: 'nowrap',
    overflow: 'scroll',
    width: 320,
    top: 0,
    bottom: 0,
    paddingBottom: 24,
    background: '#FAFAFA',

    '@media (max-width: 1180px)': {
      display: 'none',
    },
  },
  logo: {
    paddingInlineStart: 33,
    paddingInlineEnd: 33,
  },
  main: {
    minHeight: '100vh',
    marginInlineStart: 320,
    paddingBottom: 32,
    backgroundColor: variables.white,
    color: variables.black50,
    width: 'calc(100% - 320px)',

    '@media (max-width: 1180px)': {
      width: '100%',
      marginInlineStart: 0,
      paddingInlineStart: 16,
      paddingInlineEnd: 16,
    },
  },
  menuSpace: {
    minHeight: 60,
    flexGrow: 1,
    boxShadow: 'none',
  },
  bottomSection: {
    width: 288,
    textAlign: 'left',
    fontSize: 16,
    marginInlineStart: 15,
  },
  userName: {
    color: '#172D29',
    fontWeight: 590,
    width: 200,
    display: 'block',
    cursor: 'pointer',
    margin: '8px 0 4px',
  },
  id: {
    margin: '4px 0 8px',
  },
  menuButton: {
    fontSize: 16,
    fontWeight: 600,
    width: 288,
    height: 56,
    textAlign: 'start',
    color: variables.richBlack,
    justifyContent: 'flex-start',
    verticalAlign: 'middle',
    '& .MuiButton-startIcon': {
      marginBottom: 2,
      marginInlineStart: -4,
      marginInlineEnd: 8,

      '& .MuiSvgIcon-root': {
        fontSize: 17,
      },
    },

    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        backgroundColor: 'unset',
        color: variables.black50,
        '& .MuiButton-startIcon': {
          '& svg path': {
            stroke: variables.black50,
          },
        },
      },
    },
  },
  logoutButton: {
    fontSize: 16,
    fontWeight: 600,
    width: 288,
    height: 56,
    textAlign: 'start',
    color: variables.richBlack,
    justifyContent: 'flex-start',
    verticalAlign: 'middle',
    '& .MuiButton-startIcon': {
      marginBottom: 2,
      marginInlineStart: -4,
      marginInlineEnd: 6,

      '& .MuiSvgIcon-root': {
        fontSize: 17,
      },
    },

    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        backgroundColor: 'unset',
        color: variables.black50,
        '& .MuiButton-startIcon': {
          '& svg path': {
            stroke: variables.black50,
          },
        },
      },
    },
  },
  languageBtn: {
    paddingLeft: 20,

    '& .MuiButton-startIcon': {
      marginRight: 20,
    },
  },
  dialog: {
    flip: 'true',
    width: 400,
    borderRadius: 16,
    padding: '16px 32px 32px 32px',
  },
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
    gap: 16,
    paddingTop: 16,
    paddingBottom: 16,
    color: variables.richBlack,
  },
  closeBtn: {
    color: variables.richBlack,
  },
  languageItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  languageRadioBtn: {
    right: 0,
    left: 'unset',
  },
  languageRadioBtnRtl: {
    left: 0,
    right: 'unset',
  },
}));
